import $  from 'jquery';
// import debugAddInd from './../vendors/debug.addIndicators';
import gsap from './../vendors/animation.gsap';
import velocity from './../vendors/velocity.min';
//import Scene from './../vendors/animation.velocity';
import ScrollMagic from 'scrollmagic';
import TweenMax from './../vendors/TweenMax';
import lazy from './../vendors/jquery.lazy.min';
// import lazyShowPlgn from './../vendors/jquery.lazy.plugins.min';
// import iscroll from './../vendors/iscroll';
// import lettering from './../vendors/jquery.lettering-0.6.1.min';
import scrollorama from './../vendors/jquery.superscrollorama';


class marsAnimations {

  constructor() {
    this.events();

    let scrollMagicController = new ScrollMagic.Controller();

    /* Full CTA Orb */
    if ($('.fullWidth-cta__topOrb').length) {
      let scale_tween = TweenMax.from('.fullWidth-cta__topOrb', 1, {
        transform: 'scale(.75)',
        top: '-40px',
        ease: Linear.easeNone
      });
      let scene = new ScrollMagic.Scene({
        triggerElement: ".fullWidth-cta"
      })
        .setTween(scale_tween)
        .addTo(scrollMagicController);
    }

    if ($('.fullWidth-cta__bottomOrb').length) {
      let scale_tween = TweenMax.from('.fullWidth-cta__bottomOrb', 1, {
        transform: 'scale(.75)',
        bottom: '-40px',
        ease: Linear.easeNone
      });
      let scene = new ScrollMagic.Scene({
        triggerElement: ".fullWidth-cta"
      })
        .setTween(scale_tween)
        .addTo(scrollMagicController);
    }



    if ($('.timelineSection__timeline-image--orb').length) {
      let scale_tween = TweenMax.from('.timelineSection__timeline-image--orb', 1, {
        // transform: 'scale(.75)',
        delay: 0,
        left: '0px',
        opacity: 0.5,
        ease: Quad.easeInOut
      });

      let scene = new ScrollMagic.Scene({
        triggerElement: ".timelineSection__timeline-image--orb",
        offset: 100
      })
        .setTween(scale_tween)
        .reverse(true)
        .addTo(scrollMagicController);
    }


    if ($('.footer-orb').length) {
      let scale_tween = TweenMax.from('.footer-orb', 1, {
        transform: 'scale(.90)',
        right: '-20px',
        ease: Linear.easeNone
      });
      let scene = new ScrollMagic.Scene({
        triggerElement: ".footer-orb",
        offset: -400
      })
        .setTween(scale_tween)
        .addTo(scrollMagicController);
    }


    /* Innovation Portrait animations */
    function initScrollAnimations() {
      let controller = $.superscrollorama();
      let screenWidth = $(window).width();
      if (screenWidth > 768) {

        $('.marketingTemplateLayout3:eq(0) .video-right').css('position', 'relative').each(function () {
          controller.addTween('.video-right', TweenMax.from($(this), 2, {
            delay: 0,
            css: {right: Math.random() * 200 - 100, top: Math.random() * 200 - 100, opacity: 0}
            //ease: Back.easeOut
          }));
        });

        $('.marketingTemplateLayout3:eq(0) .video-left').css('position', 'relative').each(function () {
          controller.addTween('.video-left', TweenMax.from($(this), 2, {
            delay: 0,
            css: {left: Math.random() * 200 - 100, top: Math.random() * 200 - 100, opacity: 0}
            //ease: Back.easeOut
          }));
        });

        controller.addTween('.marketingTemplateLayout3:eq(1) .video-right', TweenMax.from($('.marketingTemplateLayout3:eq(1) .video-right'), 2, {
          css: {left: '1000px'},
          ease: Quad.easeInOut
        }));
        controller.addTween('.marketingTemplateLayout3:eq(1) .video-left', TweenMax.from($('.marketingTemplateLayout3:eq(1) .video-left'), 2, {
          css: {right: '1000px'},
          ease: Quad.easeInOut
        }));
        controller.addTween('.marketingTemplateLayout3:eq(0) svg', TweenMax.from($('.marketingTemplateLayout3:eq(0) svg'), 2, {
          css: {left: '10px'},
          ease: Quad.easeInOut
        }));
        controller.addTween('.marketingTemplateLayout2__bottom_media', TweenMax.from($('.marketingTemplateLayout2__bottom_media'), 2, {
          css: {left: '1200px'},
          ease: Quad.easeInOut
        }));

        controller.addTween(
          '.marketingTemplateLayout1__right:eq(1)',
          (new TimelineLite())
            .append([
              TweenMax.fromTo($('.marketingTemplateLayout1__bottom_media-video'), 2,
                {css: {'margin-top': -10}, immediateRender: true},
                {css: {'margin-top': 150}})
            ]),
          1000 // scroll duration of tween
        );

        /* Init Parallax */
        controller.addTween(
          '.marketingTemplateLayout2:eq(0)',
          (new TimelineLite())
            .append([
              TweenMax.fromTo($('.marketingTemplateLayout2__bottom_media-img'), 2,
                {css: {'margin-top': -10}, immediateRender: true},
                {css: {'margin-top': 0}})
            ]),
          1000 // scroll duration of tween
        );

        controller.addTween(
          '.marketingTemplateLayout2:eq(1)',
          (new TimelineLite())
            .append([
              TweenMax.fromTo($('.marketingTemplateLayout2__bottom_media-img'), 2,
                {css: {'margin-top': -100}, immediateRender: true},
                {css: {'margin-top': 0}})
            ]),
          1000 // scroll duration of tween
        );

        controller.addTween(
          '.marketingHeader',
          (new TimelineLite())
            .append([
              TweenMax.fromTo($('.marketingHeader__arrow'), 1,
                {css: {'margin-top': 0}, immediateRender: true},
                {css: {'margin-top': 200}}),
            ]),
          1000 // scroll duration of tween
        );


        $('.marketingTemplateLayout1:eq(0) .marketingTemplateLayout1__media, .marketingTemplateLayout1:eq(1) .marketingTemplateLayout1__media').css('position', 'relative').each(function () {
          controller.addTween('.marketingTemplateLayout1__media', TweenMax.from($(this), 2, {
            delay: 0,
            css: {left: 0, top: 40, opacity: 0},
            //css: {left: Math.random() * 300 - 100, top: Math.random() * 300 - 100, opacity: 0},
            ease: Back.easeOut
          }));
        });

        // $('.marketingTemplateLayout1__bottom_media').css('position', 'relative').each(function () {
        //   controller.addTween('.marketingTemplateLayout1__bottom_media', TweenMax.from($(this), 1, {
        //     delay: 0,
        //     css: {left: 0, top: 40, opacity: 0},
        //     //ease: Back.easeOut
        //   }));
        // });

        /* Backgrounds */
        controller.addTween('.marketingTemplateLayout1__background.solid', TweenMax.from($('.marketingTemplateLayout1__background.solid'), 2, {css: {opacity: 0}}));
        controller.addTween('.marketingTemplateLayout2__background.solid', TweenMax.from($('.marketingTemplateLayout2__background.solid'), 3, {
          css: {
            right: '-200px',
            top: '100px'
          }, ease: Quad.easeInOut
        }));
        controller.addTween('.marketingTemplateLayout3__background.solid', TweenMax.from($('.marketingTemplateLayout3__background.solid'), 2, {
          css: {right: '1000px'},
          ease: Quad.easeInOut
        }));
        controller.addTween('.marketingTemplateLayout1__background.img', TweenMax.fromTo($('.marketingTemplateLayout1__background.img'), 2, {
          css: {
            opacity: 0,
            backgroundSize: '65%',
            left: '-200px'
          }, immediateRender: true, ease: Quad.easeInOut
        }, {css: {opacity: 1, backgroundSize: 'contain', left: '0px'}, ease: Quad.easeInOut}));
      }
    }

    initScrollAnimations();


    /* LazyLoad images */
    $('.delay-img').lazy({
      scrollDirection: 'both',
      effect: 'fadeIn',
      effectTime: 1000,
      visibleOnly: true
    });
  }

  events() {

    /* Scroll to next layout */
    $('.pageHeader__arrow-down, .pageHeaderSlider__arrow-down').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: $(".sectionWrapper").offset().top}, 500, 'linear');
    });

    $('.twoColWithTabs__tabButton').on('click', function(e) {
      $('html, body').animate({ scrollTop: $(".twoColWithTabs__tabContent").offset().top - 80}, 500, 'linear');
    });


    /* Animate and fade in elements on scroll */
     let o = {};

     o.fade = function (e) {
     let t = parseInt($(e).data("enter-delay")) / 1e3 || 0;
     return (new TimelineMax).from(e, .5, {delay: t, opacity: 0, y: 50})
     }

     function i() {
      $("[data-enter]").each(function () {
        window.scrollController = window.scrollController || new ScrollMagic.Controller;
        let e = $(this)[0], t = $(this).data("enter"), a = o[t];
        if (a) {
          let n = a(e);
          new ScrollMagic.Scene({triggerElement: e, triggerHook: 1}).setTween(n).addTo(window.scrollController)
        } else console.error('Tween "' + t + '" not defined.')
      })
     }
     i();
  }
}

export default marsAnimations;